export default __webpack_public_path__ + "static/media/bg9.186b8e2e.jpg";